import type { Editor } from "@tiptap/core";
import { useEffect, type RefObject } from "react";
import { floatingBuilderOwnsChoiceAtChipPos } from "../../directives/suggestion/storage/floatingStorage";

type Args = {
  isIncomplete: boolean;
  raw: string;
  autoOpenedForRawRef: RefObject<string | null>;
  shouldFocusFirstSlotRef: { current: boolean };
  setOpen: (open: boolean) => void;
  editor: Editor;
  getPos: () => number | undefined;
};

export const useDirectiveChipIncompleteAutoOpen = ({
  isIncomplete,
  raw,
  autoOpenedForRawRef,
  shouldFocusFirstSlotRef,
  setOpen,
  editor,
  getPos,
}: Args) => {
  useEffect(
    () => {
      if (isIncomplete && autoOpenedForRawRef.current !== raw) {
        autoOpenedForRawRef.current = raw;
        if (floatingBuilderOwnsChoiceAtChipPos(editor, getPos)) {
          return;
        }
        shouldFocusFirstSlotRef.current = true;
        setOpen(true);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- refs/setOpen stable; sync to raw/incomplete only
    [isIncomplete, raw, editor, getPos],
  );
};
